(function () {
  if (window.__customAddonCartReconcileInit) return;
  window.__customAddonCartReconcileInit = true;

  var routes = (window.theme && theme.routes) || {};
  var CART_URL = routes.cart_url || '/cart';
  var CHANGE_URL = routes.cart_change_url || '/cart/change';

  // Guards against reconciling our own cart mutations into an infinite loop.
  var isReconciling = false;

  // Mirrors cart.js getSectionsToRender so we can re-render the cart UI after
  // removing orphaned add-ons. `section` is the section id to fetch; `id` is the
  // DOM element to patch; `selector` is the inner node to replace.
  function sectionsToRender() {
    var mainItems = document.getElementById('main-cart-items');
    var mainFooter = document.getElementById('main-cart-footer');
    return [
      { id: 'mini-cart', section: 'mini-cart', selector: '.shopify-section' },
      { id: 'main-cart-items', section: mainItems && mainItems.dataset.id, selector: '.js-contents' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'mobile-cart-icon-bubble', section: 'mobile-cart-icon-bubble', selector: '.shopify-section' },
      { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' },
      { id: 'main-cart-footer', section: mainFooter && mainFooter.dataset.id, selector: '.js-contents' }
    ];
  }

  function getSectionInnerHTML(html, selector) {
    var node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return node ? node.innerHTML : '';
  }

  function renderSections(state) {
    if (!state || !state.sections) return;
    sectionsToRender().forEach(function (section) {
      var element = document.getElementById(section.id);
      if (!element || !section.section) return;
      var html = state.sections[section.section];
      if (!html) return;
      var target = element.querySelector(section.selector) || element;
      target.innerHTML = getSectionInnerHTML(html, section.selector);
    });
  }

  // Mirrors cart.js: the empty-state markup is toggled via the `is-empty` class,
  // not the re-rendered innerHTML, so it must be set when removing the last item.
  function toggleEmptyState(state) {
    if (!state) return;
    var isEmpty = state.item_count === 0;
    document.querySelectorAll('cart-items').forEach(function (el) {
      el.classList.toggle('is-empty', isEmpty);
    });
    var footer = document.getElementById('main-cart-footer');
    if (footer) footer.classList.toggle('is-empty', isEmpty);
  }

  // Removes orphaned add-on lines one at a time. The final /cart/change response
  // carries the refreshed sections used to repaint the cart.
  function removeOrphans(orphans) {
    var sectionNames = sectionsToRender()
      .map(function (s) { return s.section; })
      .filter(Boolean);

    var chain = Promise.resolve(null);
    orphans.forEach(function (item) {
      chain = chain.then(function () {
        return fetch(CHANGE_URL + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: item.key,
            quantity: 0,
            sections: sectionNames,
            sections_url: window.location.pathname
          })
        }).then(function (response) {
          return response.json();
        });
      });
    });

    return chain.then(function (finalState) {
      renderSections(finalState);
      toggleEmptyState(finalState);
      // Dispatch while still guarded so this listener ignores its own event.
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart: JSON.stringify(finalState) }
      }));
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'custom-addon-cart' });
      }
    });
  }

  function reconcile() {
    if (isReconciling) return;
    isReconciling = true;

    fetch(CART_URL + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];

        // Variant ids of every non-add-on line currently in the cart.
        var presentParents = {};
        items.forEach(function (item) {
          var props = item.properties || {};
          if (props._addon) return;
          presentParents[String(item.id)] = true;
        });

        // Add-on lines whose parent variant is no longer in the cart.
        var orphans = items.filter(function (item) {
          var props = item.properties || {};
          if (!props._addon) return false;
          var parent = props._addon_parent_id;
          if (!parent) return false; // no parent reference -> never auto-remove
          return !presentParents[String(parent)];
        });

        if (!orphans.length) {
          isReconciling = false;
          return;
        }

        return removeOrphans(orphans).then(function () {
          isReconciling = false;
        });
      })
      .catch(function (e) {
        console.error('Add-on reconcile failed:', e);
        isReconciling = false;
      });
  }

  document.addEventListener('cart:updated', reconcile);

  // Initial pass cleans up orphans left over from before this feature existed.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
})();
